import { gql } from '@apollo/client';

export const FILTERED_INSTITUTION_PORTAL_INSTITUTIONS = gql`
  query FilteredInstitutionPortalInstitutions($input: InstitutionPortalInstitutionsInput!) {
    institutions: filteredInstitutionPortalInstitutions(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          district {
            id
            name
          }
          ecdRegistrationProgress
          latestUnsubmittedECDRegistration {
            id
            approvalStatus
            modifiedBy {
              id
            }
          }
          localMunicipality {
            id
            localMunicipality
            localMunicipalityShorthand
          }
          name
          registrationOffice {
            id
            isInstitution
            isServiceProvider
            institution {
              id
              name
            }
            serviceProvider {
              id
              name
            }
          }
          streetAddress
          streetNo
          type {
            id
            name
          }
          verified
          validated
          wardID
          wardLabel
          duplicateReference
          duplicateAction
          isArchived
          pcrLevel
          progLevel
          emisNumber
          trackingCode
          province {
            id
            name
          }
        }
      }
    }
  }
`;
